import React from "react";
import "./toggler.css";

const Toggler = ({ darkMode, onToggle }) => {
  return (
    <div className="toggle">
      {" "}
      <span>Dark Mode</span>
      <label className="switch">
        <input type="checkbox" onChange={() => onToggle()} />
        <span
          className={
            darkMode ? "slider round dark" : "slider round light"
          }></span>
      </label>{" "}
    </div>
  );
};

export default Toggler;
